import ariz from './Ariz/Config';

export default {
  ...ariz,
};
